import http from "@/http/axios";
import { appModule } from "@/store/modules/app";

export async function getPlaceList() {
  const result = await http.get(`/place`);
  if (result) {
    if (result.data.status === "Success") {
      return result.data.data.place;
    } else {
      appModule.sendErrorNotice("取得地區列表失敗");
    }
  } else {
    appModule.sendErrorNotice("取得地區列表失敗");
  }
}


export async function getAllPlaceList() {
  const result = await http.get(`/place/all`);
  if (result) {
    if (result.data.status === "Success") {
      return result.data.data.place;
    } else {
      appModule.sendErrorNotice("取得地區列表失敗");
    }
  } else {
    appModule.sendErrorNotice("取得地區列表失敗");
  }
}

export async function getCommunityStatistic(communityList: string[]){
  const params = {
    'communityList':communityList
  }
  const result = await http.post(`/place/community/statistic`,params);
  if(result){
    if(result.data.status === "Success"){
      return result.data.data;
    } else{
      appModule.sendErrorNotice("取得地區統計資料失敗");
    }
  } else {
    appModule.sendErrorNotice("取得地區統計資料失敗");
  }
}

export async function getCommunityHistory(options){
  const result = await http.get(`/place/community/statistic/${options.placefc}?page=${options.page}&limit=10`);
  if(result){
    if(result.data.status === "Success"){
      return result.data.data;
    } else{
      appModule.sendErrorNotice("取得地區統計資料失敗");
    }
  } else {
    appModule.sendErrorNotice("取得地區統計資料失敗");
  }
}

export async function getCommunityHistoryByDate(date){
  const result = await http.get(`/place/community/statistic?date=${date}`);
  if(result){
    if(result.data.status === "Success"){
      return result.data.data;
    } else{
      appModule.sendErrorNotice("取得地區統計資料失敗");
    }
  } else {
    appModule.sendErrorNotice("取得地區統計資料失敗");
  }
}

/**
 * 取得單一月份的社區狀態快照（後端排程 app.apscheduler:store_community_state 寫入的資料）。
 * 與 getCommunityHistoryByDate 打同一支 API，差別在於：
 *  - silent = true 時不跳錯誤通知，供背景預抓鄰月使用（使用者沒點的月份不該噴 toast）
 *  - 失敗時明確回傳 null，讓呼叫端能區分「錯誤」與「該月無資料（空陣列）」
 */
export async function getCommunityStatisticByMonth(date: string, silent = false){
  const result = await http.get(`/place/community/statistic?date=${date}`);
  if(result){
    if(result.data.status === "Success"){
      return result.data.data;
    } else{
      if(!silent) appModule.sendErrorNotice("取得歷史地圖資料失敗");
      return null;
    }
  } else {
    if(!silent) appModule.sendErrorNotice("取得歷史地圖資料失敗");
    return null;
  }
}

export async function getPlaceDisplay(){
  const result = await http.get(`/place/community/display`);
  if(result){
    if(result.data.status === "Success"){
      return result.data;
    } else{
      appModule.sendErrorNotice("取得地區統計資料失敗");
    }
  } else {
    appModule.sendErrorNotice("取得地區統計資料失敗");
  }
}
